import { getLogInAsHeaders, LogInAsHeaderNames } from '@fusion/saas-components-v3'
import type {
  Study,
  CsvFileCount,
  StudyRegistrationHardware,
  UsedStorage
} from '@/types/studies'
import { GET } from './helpers'

export const getLatestStudyRegistrations = async function () {
  return GET<StudyRegistrationHardware[]>(
    '/studies/registration/serials/latest?ignoredGatewayModels=sbd1,SBD1,SmartBridge',
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.SAP_ID])
    },
    {},
    APP_ENV.VITE_APP_STUDIES_HOST_V2
  )
}

export const buildQueryString = (includeChildren: boolean, includeOnlyLatestTelemetry: boolean) => {
  const queryParams = []

  if (includeChildren) {
    queryParams.push('study_type=timeseries', 'study_type=stel')
  } else {
    queryParams.push('study_type=timeseries')
  }

  if (includeOnlyLatestTelemetry) {
    queryParams.push('latest_telemetry=true')
  }

  return queryParams.length > 0 ? `?${queryParams.join('&')}` : ''
}

export const getLatestDeviceStudy = async function (
  devId: string,
  includeChildren: boolean,
  includeOnlyLatestTelemetry: boolean
) {
  const queryString = buildQueryString(includeChildren, includeOnlyLatestTelemetry)
  const endpoint = `/studies/devices/${devId}/latest${queryString}`
  return GET<Study>(endpoint, {}, {}, APP_ENV.VITE_APP_STUDIES_HOST_V3)
}

export const getFileImportCount = async function () {
  return GET<CsvFileCount>(
    '/studies/registration/file-import',
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.SAP_ID, LogInAsHeaderNames.ACCOUNT_ID])
    },
    {},
    APP_ENV.VITE_APP_STUDIES_HOST_V2
  )
}

export const getTotalStorageUsed = async function () {
  return GET<UsedStorage>(
    '/studies/storage',
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.SAP_ID, LogInAsHeaderNames.ACCOUNT_ID])
    },
    {},
    APP_ENV.VITE_APP_STUDIES_HOST_V2
  )
}
